export default "__VITE_ASSET__DZgwZ_ru__"